<template>
  <div>
    <Header />
    <div class="pt80">
      <div id="section1">
        <div class="container">
          <div class="th2">新闻资讯</div>
        </div>
      </div>
      <div id="section2">
        <div class="container">
          <div class="realtime">
            <img src="@/assets/news.png" width="289px" />
            <div>
              <div class="th2">
                促进中哈经贸合作，“数贸之夜”上，这两个项目签约
              </div>
              <div class="th3">2024-09-25</div>
              <div class="txt">
                9月25日至29日，第三届全球数字贸易博览会在杭举行。在25日晚举行的“数贸之夜”活动中，科里扎特智慧化口岸项目、中哈人民币结算及跨境支付项目签约。
              </div>
            </div>
          </div>

          <div class="news">
            <div class="news-li" @click="openNews(1)">
              <div class="news-li-tit">
                <i></i>促进中哈经贸合作，“数贸之夜”上，这两个项目签约
              </div>
              <div class="news-li-date">2024/9/26</div>
            </div>
            <div class="news-li" @click="openNews(2)">
              <div class="news-li-tit">
                <i></i>促进中哈经贸合作，“数贸之夜”上，这两个项目签约
              </div>
              <div class="news-li-date">2024/9/26</div>
            </div>
            <div class="news-li" @click="openNews(3)">
              <div class="news-li-tit">
                <i></i>促进中哈经贸合作，“数贸之夜”上，这两个项目签约
              </div>
              <div class="news-li-date">2024/9/26</div>
            </div>
            <div class="news-li" @click="openNews(4)">
              <div class="news-li-tit">
                <i></i>促进中哈经贸合作，“数贸之夜”上，这两个项目签约
              </div>
              <div class="news-li-date">2024/9/26</div>
            </div>
            <div class="news-li" @click="openNews(5)">
              <div class="news-li-tit">
                <i></i>促进中哈经贸合作，“数贸之夜”上，这两个项目签约
              </div>
              <div class="news-li-date">2024/9/26</div>
            </div>
          </div>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="1"
            style="text-align: center"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import "@/assets/css/animate.css";
export default {
  name: "news",
  components: { Header, Footer },
  data() {
    return {};
  },
  methods: {
    openNews(index) {
      this.$router.push({ path: "/newsDetails", query: { index } });
    },
  },
};
</script>

<style lang="less" scoped>
.pt80 {
  padding-top: 80px;
}

.container {
  padding: 0;
}

#section1 {
  height: 144px;
  background-image: url(~@/assets/news-1.png);
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  .container {
    position: relative;
  }
  .th {
    margin-top: 18px;
    font-weight: 500;
    font-size: 20px;
    color: #3b3b3b;
    line-height: 20px;
    i {
      &:last-child {
        margin-left: -20px;
      }
    }
  }
  .th2 {
    margin-top: 30px;
    font-weight: 300;
    font-size: 64px;
    color: #1485ef;
    line-height: 78px;
  }
  .txt {
    width: 894px;
    font-weight: 350;
    font-size: 16px;
    color: #888888;
    line-height: 28px;
  }
}

#section2 {
  .container {
    padding: 0 40px 100px;
  }
  .realtime {
    margin: 45px 0;
    display: flex;
    img {
      margin-right: 29px;
    }
    > div {
      width: 600px;
    }
    .th2 {
      font-weight: 700;
      font-size: 30px;
      color: #3e3e3e;
      line-height: 36px;
    }
    .th3 {
      font-weight: 400;
      font-size: 24px;
      color: rgba(158, 158, 158, 0.37);
      line-height: 36px;
    }
    .txt {
      font-weight: 400;
      font-size: 14px;
      color: #9e9e9e;
      line-height: 21px;
    }
  }
  .news-li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 890px;
    height: 100px;
    border-bottom: 1px solid #d8d8d8;
    cursor: pointer;
    &:last-child {
      border-bottom: none;
    }
    .news-li-tit {
      display: flex;
      align-items: center;
      font-weight: 700;
      font-size: 24px;
      color: #3e3e3e;
      line-height: 29px;
      i {
        margin: 0 15px;
        display: inline-block;
        width: 17px;
        height: 6px;
        background: #1485ef;
        border-radius: 10px;
      }
    }
    .news-li-date {
      font-weight: 400;
      font-size: 24px;
      color: #9e9e9e;
      line-height: 29px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/news.vue